

export const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    // (?=.*[A-Z]): Ensures at least one uppercase letter.
    // (?=.*[0-9]): Ensures at least one digit.
    // (?=.*[!@#$%^&*]): Ensures at least one special character.
    // [A-Za-z\d!@#$%^&*]{8,}: Ensures the total length is 8 or more characters.

   export const countryCodes = [
  // East Africa
  { code: "+255", country: "Tanzania", flag: "🇹🇿", example: "712345678" },
  { code: "+256", country: "Uganda", flag: "🇺🇬", example: "712345678" },
  { code: "+254", country: "Kenya", flag: "🇰🇪", example: "712345678" },
  { code: "+250", country: "Rwanda", flag: "🇷🇼", example: "788123456" },
  { code: "+257", country: "Burundi", flag: "🇧🇮", example: "71234567" },
  { code: "+251", country: "Ethiopia", flag: "🇪🇹", example: "912345678" },
  { code: "+252", country: "Somalia", flag: "🇸🇴", example: "612345678" },
  { code: "+211", country: "South Sudan", flag: "🇸🇸", example: "912345678" },
  { code: "+253", country: "Djibouti", flag: "🇩🇯", example: "77812345" },
  { code: "+290", country: "Saint Helena", flag: "🇸🇭", example: "51234" },
  
  // North Africa
  { code: "+20", country: "Egypt", flag: "🇪🇬", example: "1012345678" },
  { code: "+218", country: "Libya", flag: "🇱🇾", example: "912345678" },
  { code: "+216", country: "Tunisia", flag: "🇹🇳", example: "20123456" },
  { code: "+213", country: "Algeria", flag: "🇩🇿", example: "551234567" },
  { code: "+212", country: "Morocco", flag: "🇲🇦", example: "612345678" },
  { code: "+222", country: "Mauritania", flag: "🇲🇷", example: "22123456" },
  { code: "+249", country: "Sudan", flag: "🇸🇩", example: "912345678" },
  
  // West Africa
  { code: "+234", country: "Nigeria", flag: "🇳🇬", example: "8021234567" },
  { code: "+233", country: "Ghana", flag: "🇬🇭", example: "201234567" },
  { code: "+225", country: "Ivory Coast", flag: "🇨🇮", example: "01234567" },
  { code: "+226", country: "Burkina Faso", flag: "🇧🇫", example: "70123456" },
  { code: "+227", country: "Niger", flag: "🇳🇪", example: "90123456" },
  { code: "+221", country: "Senegal", flag: "🇸🇳", example: "771234567" },
  { code: "+223", country: "Mali", flag: "🇲🇱", example: "70123456" },
  { code: "+224", country: "Guinea", flag: "🇬🇳", example: "601234567" },
  { code: "+245", country: "Guinea-Bissau", flag: "🇬🇼", example: "955123456" },
  { code: "+232", country: "Sierra Leone", flag: "🇸🇱", example: "76123456" },
  { code: "+231", country: "Liberia", flag: "🇱🇷", example: "770123456" },
  { code: "+229", country: "Benin", flag: "🇧🇯", example: "90123456" },
  { code: "+228", country: "Togo", flag: "🇹🇬", example: "90123456" },
  { code: "+235", country: "Chad", flag: "🇹🇩", example: "66234567" },
  { code: "+236", country: "Central African Republic", flag: "🇨🇫", example: "70012345" },
  { code: "+239", country: "Sao Tome and Principe", flag: "🇸🇹", example: "9812345" },
  { code: "+238", country: "Cape Verde", flag: "🇨🇻", example: "9911234" },
  { code: "+220", country: "Gambia", flag: "🇬🇲", example: "3012345" },
  
  // Central Africa
  { code: "+237", country: "Cameroon", flag: "🇨🇲", example: "612345678" },
  { code: "+242", country: "Congo Republic", flag: "🇨🇬", example: "061234567" },
  { code: "+243", country: "DR Congo", flag: "🇨🇩", example: "812345678" },
  { code: "+241", country: "Gabon", flag: "🇬🇦", example: "06123456" },
  { code: "+240", country: "Equatorial Guinea", flag: "🇬🇶", example: "222123456" },
  { code: "+244", country: "Angola", flag: "🇦🇴", example: "912345678" },
  { code: "+247", country: "Ascension Island", flag: "🇦🇨", example: "61234" },
  
  // Southern Africa
  { code: "+27", country: "South Africa", flag: "🇿🇦", example: "712345678" },
  { code: "+264", country: "Namibia", flag: "🇳🇦", example: "811234567" },
  { code: "+267", country: "Botswana", flag: "🇧🇼", example: "71234567" },
  { code: "+263", country: "Zimbabwe", flag: "🇿🇼", example: "712345678" },
  { code: "+258", country: "Mozambique", flag: "🇲🇿", example: "821234567" },
  { code: "+260", country: "Zambia", flag: "🇿🇲", example: "966123456" },
  { code: "+265", country: "Malawi", flag: "🇲🇼", example: "991234567" },
  { code: "+266", country: "Lesotho", flag: "🇱🇸", example: "50123456" },
  { code: "+268", country: "Swaziland/Eswatini", flag: "🇸🇿", example: "76123456" },
  { code: "+269", country: "Comoros", flag: "🇰🇲", example: "3212345" },
  { code: "+262", country: "Réunion", flag: "🇷🇪", example: "692123456" },
  { code: "+230", country: "Mauritius", flag: "🇲🇺", example: "52561234" },
  { code: "+248", country: "Seychelles", flag: "🇸🇨", example: "2512345" },
  { code: "+246", country: "Diego Garcia", flag: "🇩🇬", example: "1234567" },
  
  // Other major countries (keeping original plus adding more)
  { code: "+1", country: "USA/Canada", flag: "🇺🇸", example: "2125551234" },
  { code: "+44", country: "UK", flag: "🇬🇧", example: "7700900123" },
  { code: "+91", country: "India", flag: "🇮🇳", example: "9876543210" },
  { code: "+61", country: "Australia", flag: "🇦🇺", example: "412345678" },
  { code: "+49", country: "Germany", flag: "🇩🇪", example: "15123456789" },
  { code: "+33", country: "France", flag: "🇫🇷", example: "612345678" },
  { code: "+81", country: "Japan", flag: "🇯🇵", example: "9012345678" },
  { code: "+86", country: "China", flag: "🇨🇳", example: "13812345678" },
  { code: "+55", country: "Brazil", flag: "🇧🇷", example: "11987654321" },
  { code: "+971", country: "UAE", flag: "🇦🇪", example: "501234567" },
  { code: "+966", country: "Saudi Arabia", flag: "🇸🇦", example: "512345678" },
  { code: "+65", country: "Singapore", flag: "🇸🇬", example: "91234567" },
  { code: "+60", country: "Malaysia", flag: "🇲🇾", example: "123456789" },
  { code: "+64", country: "New Zealand", flag: "🇳🇿", example: "211234567" },
  { code: "+82", country: "South Korea", flag: "🇰🇷", example: "1012345678" },
  { code: "+34", country: "Spain", flag: "🇪🇸", example: "612345678" },
  { code: "+39", country: "Italy", flag: "🇮🇹", example: "3123456789" },
  { code: "+7", country: "Russia", flag: "🇷🇺", example: "9123456789" },
  { code: "+52", country: "Mexico", flag: "🇲🇽", example: "5512345678" },
  
  // Additional European countries
  { code: "+31", country: "Netherlands", flag: "🇳🇱", example: "612345678" },
  { code: "+32", country: "Belgium", flag: "🇧🇪", example: "471234567" },
  { code: "+41", country: "Switzerland", flag: "🇨🇭", example: "791234567" },
  { code: "+46", country: "Sweden", flag: "🇸🇪", example: "701234567" },
  { code: "+47", country: "Norway", flag: "🇳🇴", example: "41234567" },
  { code: "+45", country: "Denmark", flag: "🇩🇰", example: "20123456" },
  { code: "+358", country: "Finland", flag: "🇫🇮", example: "401234567" },
  { code: "+48", country: "Poland", flag: "🇵🇱", example: "501234567" },
  { code: "+420", country: "Czech Republic", flag: "🇨🇿", example: "601123456" },
  { code: "+36", country: "Hungary", flag: "🇭🇺", example: "201234567" },
  { code: "+43", country: "Austria", flag: "🇦🇹", example: "664123456" },
  { code: "+40", country: "Romania", flag: "🇷🇴", example: "712345678" },
  { code: "+359", country: "Bulgaria", flag: "🇧🇬", example: "881234567" },
  { code: "+30", country: "Greece", flag: "🇬🇷", example: "6912345678" },
  { code: "+351", country: "Portugal", flag: "🇵🇹", example: "912345678" },
  { code: "+353", country: "Ireland", flag: "🇮🇪", example: "851234567" },
  
  // Asian countries
  { code: "+62", country: "Indonesia", flag: "🇮🇩", example: "8123456789" },
  { code: "+66", country: "Thailand", flag: "🇹🇭", example: "812345678" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳", example: "912345678" },
  { code: "+63", country: "Philippines", flag: "🇵🇭", example: "9123456789" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰", example: "3123456789" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰", example: "712345678" },
  { code: "+95", country: "Myanmar", flag: "🇲🇲", example: "912345678" },
  { code: "+856", country: "Laos", flag: "🇱🇦", example: "2023123456" },
  { code: "+855", country: "Cambodia", flag: "🇰🇭", example: "91234567" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩", example: "1712345678" },
  { code: "+977", country: "Nepal", flag: "🇳🇵", example: "9812345678" },
  { code: "+98", country: "Iran", flag: "🇮🇷", example: "9123456789" },
  { code: "+964", country: "Iraq", flag: "🇮🇶", example: "7701234567" },
  { code: "+963", country: "Syria", flag: "🇸🇾", example: "944123456" },
  { code: "+962", country: "Jordan", flag: "🇯🇴", example: "791234567" },
  { code: "+961", country: "Lebanon", flag: "🇱🇧", example: "71123456" },
  { code: "+972", country: "Israel", flag: "🇮🇱", example: "501234567" },
  { code: "+90", country: "Turkey", flag: "🇹🇷", example: "5312345678" },
  
  // South American countries
  { code: "+54", country: "Argentina", flag: "🇦🇷", example: "91123456789" },
  { code: "+56", country: "Chile", flag: "🇨🇱", example: "912345678" },
  { code: "+57", country: "Colombia", flag: "🇨🇴", example: "3012345678" },
  { code: "+51", country: "Peru", flag: "🇵🇪", example: "912345678" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪", example: "4121234567" },
  { code: "+593", country: "Ecuador", flag: "🇪🇨", example: "991234567" },
  { code: "+591", country: "Bolivia", flag: "🇧🇴", example: "71234567" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾", example: "961234567" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾", example: "94123456" },
  { code: "+507", country: "Panama", flag: "🇵🇦", example: "61234567" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷", example: "83123456" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮", example: "81234567" },
  { code: "+504", country: "Honduras", flag: "🇭🇳", example: "91234567" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻", example: "70123456" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹", example: "51234567" },
  { code: "+501", country: "Belize", flag: "🇧🇿", example: "6123456" },
  { code: "+53", country: "Cuba", flag: "🇨🇺", example: "51234567" },
  { code: "+1-809", country: "Dominican Republic", flag: "🇩🇴", example: "8091234567" },
  { code: "+1-876", country: "Jamaica", flag: "🇯🇲", example: "8761234567" },
  { code: "+1-868", country: "Trinidad and Tobago", flag: "🇹🇹", example: "8681234567" }
];